// 登录组件
<template>
  <div class="box">
      <div class="logo">
        <span><img src="../../assets/images/user/touxiang.svg"/></span>
        <!-- <h4>会员服务系统</h4> -->
      </div>
      <div class="content">
        <div class="login-box">
          <van-field
            v-if="mobileLoginStatus == 1"
            class="input-item"
            left-icon="manager"
            label="账号"
            v-model.trim="name"
            clearable
            placeholder="请输入您的登录名或手机号"
          ></van-field>
          <van-field
            v-if="mobileLoginStatus == 1"
            class="input-item"
            label="密码"
            :type="isShowPW ? 'password' : ''"
            left-icon="lock"
            :right-icon="isShowPW ? 'closed-eye' : 'eye-o'"
            @click-right-icon="isShowPW = !isShowPW"
            v-model.trim="password"
            clearable
            placeholder="请输入您的密码"
          ></van-field>
          <van-field
            v-if="mobileLoginStatus == 2"
            class="input-item"
            left-icon="phone"
            v-model.trim="mobile"
            label="手机号"
            clearable
            placeholder="请输入手机号码"
          ></van-field>
          <van-field
            v-if="mobileLoginStatus == 2"
            class="input-item"
            v-model="code"
            left-icon="edit"
            center
            label="验证码"
            clearable
            placeholder="请输入短信验证码"
          >
            <van-button
              :disabled="isDisabled"
              slot="button"
              size="small"
              type="primary"
              @click="getCode"
            >
              {{isSend? time + 's后重新获取':'获取验证码'}}
            </van-button>
          </van-field>
          <div class="btn-list">
            <span @click="go('getPassword')">忘记密码?</span>
            <span @click="mobileLogin">{{
              mobileLoginStatus === 1 ? "手机号码登录" : "账号密码登录"
            }}</span>
            <!-- <span>意见反馈</span> -->
          </div>
          <van-button class="loginBtn" type="primary" size="large" @click="login">登录</van-button>
          <van-button class="loginBtn" type="primary" size="large" @click="go('meetRegister')" plain>注册</van-button>
        </div>
      </div>
  </div>
</template>

<script>
import { Field, Button, Toast } from "vant";
import { getUser } from "@/api/dictionary";
import {
  getDivisionData,
  getCommonDictionary,
  getMobileLoginCode,
} from "@/api/login";
import { mapActions, mapMutations } from "vuex";
import { setSessionStore } from "@/utils/sessionStorage";

export default {
  data() {
    return {
      name: "",
      password: "",
      isShowPW: true,
      screenHeightNoChange: true,
      grant_type: "password",
      mobileLoginStatus: 1,
      time: 60,
      isSend: false,
      isDisabled: false,
      mobile: "",
      code: "",
      userInfo:{}
    };
  },
  computed: {
    registerType() {
      return this.$route.query && this.$route.query.registerType;
    },
    meetingId(){
      return this.$route.query && this.$route.query.meetingId
    }
  },
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
  },
  methods: {
    ...mapActions(["securityCheck"]),
    ...mapMutations(["setMemberInfo"]),
    go(type) {
      this.$router.push({ name: type });
    },
    getUserInfo() {
      return new Promise((resolve) => {
        getUser().then((res) => {
          if (res.success) {
            this.userInfo = res.result;
            this.setMemberInfo(res.result);
            setSessionStore("memberId", res.result.id);
            resolve();
          } else {
            Toast("用户信息获取失败");
          }
        });
      });
    },
    mobileLogin() {
      if (this.mobileLoginStatus == 1) {
        this.mobileLoginStatus = 2;
        this.grant_type = "sms";
      } else {
        this.mobileLoginStatus = 1;
        this.grant_type = "password";
      }
    },
    async getCode() {
      let mobile = this.mobile;

      if (this.isSpend) {
        return;
      }

      if (!this.$regexp.mobile(mobile)) {
        Toast("请输入正确的手机号");
        return false;
      }

      getMobileLoginCode({ mobile }).then((res) => {
        if (res.success) {
          this.isSpend = true;
          this.time = 60;
          this.count();
        }
      });
    },
    count() {
      --this.time;
      if (this.time > 0) {
        setTimeout(() => {
          this.count();
        }, 1000);
      } else {
        this.isSpend = false;
      }
    },
    submit() {
      var params = {
        username: this.name,
        password: this.password,
        grant_type: this.grant_type,
        scope: "server",
        client_id: "mms_meeting",
        client_secret: 123456,
        mobile: this.mobile,
        code: this.code,
      };

      this.securityCheck(params)
        .then((res) => {
          this.getUserInfo()
            .then((res) => {
              if(this.registerType==1){
                this.$router.push({ name: "signup",query:{meetingId:this.meetingId}});
              }else{
                this.$router.push({ name: "MeetingList" });
              }
            })
            .catch(() => {
              Toast("用户信息获取失败");
            });
        })
        .catch((res) => {
          Toast(res.error_description);
        });
    },
    login() {
      if (this.mobileLoginStatus == 2) {
        if (!this.mobile) {
          Toast("手机号不能为空");
          return;
        } else if (!this.code) {
          Toast("验证码不能为空");
          return;
        }
      } else {
        if (!this.name) {
          Toast("用户名不能为空");
          return;
        } else if (!this.password) {
          Toast("密码不能为空");
          return;
        }
      }

      this.submit();
    },
  },
  mounted() {
    var url = window.location.href; //获取url中"?"符后的字串 ('?modFlag=business&role=1')
    //var url = "http://localhost:8081/#/signupSearch?meetingId=c940d6bb-0be9-4c36-afac-35078866e643";
    let begin = url.indexOf("?");
    let a = url.substring(begin, url.length);
    var theRequest = new Object();
    if (a.indexOf("?") != -1) {
      var str = a.substr(1); //substr()方法返回从参数值开始到结束的字符串；
      var strs = str.split("&");
      for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
      }
      const tid = theRequest.tid;
      console.log(tid)
      sessionStorage.setItem("tid", tid);
    }
    const self = this;
    window.onresize = () => {
      if (self.oldFullHeight) {
        self.screenHeightNoChange =
          document.documentElement.clientHeight === self.oldFullHeight;
      }
    };
  },
};
</script>

<style  lang="less" scoped>
  .logo {
    text-align: center;
    font-size: 18px;
    margin-top: 21%;
    color: #228ccd;
    span{ width:80px; height: 80px; display: block; margin: 0 auto; margin-bottom: 20px;}
    img {
      display: block;
      width:100%;
      margin: 0 auto;
    }
  
  .btn-box {
    display: flex;
    margin-top: 46px;
    justify-content: space-evenly;
    color: #ffffff;
    span{font-size: 16px !important;}
    div {
      display: flex;
      width: 50%;
      text-align: center;
      justify-content: center;
      span {
        &.active::after {
          display: block;
          content: "";
          height: 3px;
          background: #ffffff;
          border-radius: 30px;
          margin-top: 10px;
        }
      }
    }
  }
}
.content {
  padding: 0 25px;
}
.login-box {
  padding: 55px 0;
}
.input-item {
  padding: 0;
  padding-bottom: 12px;
  i {
    color: #aaa;
    margin-right: 10px;
  }
  & + .input-item {
    margin-top: 30px;
  }
}
.loginBtn {
  margin-top: 20px !important;
}
.btn-list {
  display: flex;
  margin: 30px 0;
  font-size: 14px;
  justify-content: space-between;
  color: #7d7d7d;
}
/deep/.van-field__label{ width:1.6rem}
</style>
